import { Action } from "../../actions/types";
import {
  APPLE_WALLET_CHANNEL,
  PRODUCT_APPLE_WALLET_CHANNEL,
} from "../../constants";
import { Referral } from "./index";

export const initialState = {};

type StoreState = Referral | {};

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  if (
    action.type === "GET_REFERRAL_SUCCESS" &&
    action.data &&
    (action.data.channel === APPLE_WALLET_CHANNEL ||
      action.data.channel === PRODUCT_APPLE_WALLET_CHANNEL)
  ) {
    return { ...state, ...action.response.data };
  }

  return state;
}
